/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionthinker3Inputs */



/**
* | output |
* | --- |
* | "You’re constantly analyzing the world. You love getting to the bottom of things, learning new stuff, and having long late‑night talks about how the universe ..." |
*
* @param {Personalityarchetypedescriptionthinker3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionthinker3 = /** @type {((inputs?: Personalityarchetypedescriptionthinker3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionthinker3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re constantly analyzing the world. You love getting to the bottom of things, learning new stuff, and having long late‑night talks about how the universe works.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Constantemente estás analizando el mundo. Te encanta llegar al fondo de las cosas, aprender algo nuevo y tener conversaciones nocturnas sobre el universo.")
	return /** @type {LocalizedString} */ ("Ты постоянно анализируешь мир. Тебе нравится докапываться до сути вещей, изучать новое и вести долгие разговоры об устройстве вселенной в три часа ночи.")
});
export { personalityarchetypedescriptionthinker3 as "personalityArchetypeDescriptionThinker" }